import AdminComponent from "../components/admin/AdminComponent";
import FooterComponent from "../components/FooterComponent";
import HeaderComponent from "../components/HeaderComponent";

const AdminPage = () => {
  return (
    <div>
        <HeaderComponent/>
        <AdminComponent/>
        <FooterComponent/>
    </div>
  );
};

export default AdminPage;